<template>
  <div v-if="!showDetails">
    <!-- <div style="width: 100%">
      <div class="divider dparent">
        <b> دوره های فعال</b>
      </div>
    </div> -->
    <div v-if="$store.getters.openCycles.length > 0">
      <div v-if="openCycles.length > 0">
        <app-list v-for="index in openCycles.length" :key="index" :index="index - 1" :cycle="openCycles[index - 1]"
          :showDetails="false" @clicked="onClickCycle">
        </app-list>
      </div>
      <!-- <div v-else style="margin: 10px 30px">
       
      </div> -->

      <!-- <div style="width: 100%" v-if="inactiveCycles.length > 0">
      <div class="divider dparent dinactive">
        <b> دوره های غیر فعال</b>
      </div>
    </div> -->
      <div v-if="inactiveCycles.length > 0">
        <app-list v-for="index in inactiveCycles.length" :key="index" :index="index - 1"
          :cycle="inactiveCycles[index - 1]" :showDetails="false" @clicked="onClickInactiveCycle">
        </app-list>
      </div>
    </div>
    <div v-else style="margin: 20px">
      {{ loadingMessage }}
    </div>
  </div>
  <div v-else>
    <app-list :index="selectedCycle" :cycle="openCycles[selectedCycle]" :showDetails="true">
    </app-list>
    <app-detail :cycle="openCycles[selectedCycle]"> </app-detail>
  </div>
</template>

<script>
import OpenList from "./OpenList";
import OpenDetail from "./OpenDetail";
export default {
  components: {
    appList: OpenList,
    appDetail: OpenDetail,
  },
  data() {
    return {
      selectedCycle: -1,
      loadingMessage: "در حال دریافت لیست دوره ها...",
    };
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getOpenCycles").then(() => {
      if (this.$store.getters.openCycles.length == 0) {
        this.loadingMessage = "در حال حاضر دوره فعالی برای نمایش وجود ندارد.";
      }
    });
  },
  computed: {
    openCycles() {
      return this.$store.getters.openCycles.filter((single) => {
        return single.State == "ok";
      });
      // return [];
    },
    inactiveCycles() {
      return this.$store.getters.openCycles.filter((single) => {
        return single.State != "ok";
      });
    },
    showDetails() {
      return this.selectedCycle > -1;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  methods: {
    /**
     * show available classes
     */
    onClickCycle(index) {
      this.$store.commit("SET_HEADER_TITLE", "جزییات دوره");
      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });
    },
    onClickInactiveCycle(index) {
      this.$store.commit("SET_SNACKBAR_TEXT", this.inactiveCycles[index].State);
    },
  },
  watch: {

    '$route'(to, from) {
      this.selectedCycle = this.$route.query.index ?? -1;

    }
  },


};
</script>
<style>
.v-tabs-items {
  min-height: calc(100vh - 140px);
  overflow-y: auto;
}

.v-tab {
  letter-spacing: 0;
}

.fixedPosition {
  top: 60px;
}

.dinactive::before,
.dinactive::after {
  border-bottom: 32px solid orangered !important;
}
</style>
